<template>
  <slot
    :terminate="terminate"
    :loading="loading"
  />
</template>

<script setup lang="ts">
import { useRenderNotifier } from '@wui/common-library'
import { computed, ref } from 'vue'

import { RTCSessionFacade, STATE, STATUS_CODES, useWebRTC } from '@/entities/webrtc'

import { useLocalization } from '@/shared/composables/localization'

const props = defineProps<{
  sessionId: string
}>()

const { getRTCSessionFacadeById } = useWebRTC()
const { notifyError } = useRenderNotifier()
const { t } = useLocalization()

const TERMINATE_CONFIG = { status_code: STATUS_CODES.BUSY_HERE }

const facade = computed<RTCSessionFacade | undefined>(() => getRTCSessionFacadeById(props.sessionId))
const state = computed(() => facade.value?.sessionState.value)

const loading = ref(false)
const terminate = () => {
  if (loading.value) return
  if (!facade.value) {
    console.error('Не найден RTCSessionFacade по id: ' + props.sessionId)
    return
  }
  try {
    loading.value = true
    if (state.value === STATE.RINGING) {
      facade.value.terminate(TERMINATE_CONFIG)
    } else {
      facade.value.terminate()
    }
  } catch (e) {
    const errorMessage = e instanceof Error ? e.message : t('common.unknownError')
    notifyError(errorMessage)
    console.error(e)
  } finally {
    loading.value = false
  }
}
</script>
